module.exports = __webpack_public_path__ + "img/india.65fa431e.jpg";